import React, { useState, useEffect } from 'react';
import useCancellationToken from 'utils/customHook/useCancellationToken';

import MainPopup from '../../MainPopup';
import { statusMap } from 'utils/code';
import { nvl } from 'utils/nvl';

const MainMapInfoPopup = (props) => {
  const cancellationToken = useCancellationToken();

  useEffect(() => () => cancellationToken.cancel(), [cancellationToken]);

  return (
    <>
      <div style={{ background: `#272F3C`, borderRadius: `10px`, padding: `10px` }}>
        <div style={{ display: `flex`, justifyContent: `center`, alignItems: `center`, fontSize: `35px` }}>
          <div style={{ display: `flex`, justifyContent: `center`, alignItems: `center`, flex: `8` }}>
            {statusMap[props.status]} /&nbsp;
            {props.moduleType === 'IT' ? '고정' : '이동'} /&nbsp;
            {props.moduleType === 'DT' && `${nvl(props.userNm, 'NA')} / ${nvl(props.userTel, 'NA')} / `}
            {props.modelNm}
          </div>
        </div>
        <MainPopup {...props} />
      </div>
    </>
  );
};

export default MainMapInfoPopup;
